export default class Occurence
{
  constructor(names, descriptions, tags, photos, latitude, longitude, address, type, startTime, endTime) 
  {
    // {} instead of array to support stringify
    this.names = names;
    this.descriptions = descriptions;
    this.tags = tags;

    this.photos = photos;

    this.latitude = latitude;
    this.longitude = longitude;
    this.address = address;
    this.type = type;
    this.startTime = startTime;
    this.endTime = endTime;
  }    

  isValid()
  {
    var result = true;

    for (const [key, value] of Object.entries(this.names)) { if(!value) { result = false; break; }; } // Descriptions
    if(result) for (const [key, value] of Object.entries(this.descriptions)) { if(!value) { result = false; break; }; } // Titles
    if(result) for (const [key, value] of Object.entries(this.tags)) { if(!value || !value.length) { result = false; break; }; } // JobTitles

    if(result) result = this.photos && this.photos.length && this.type && this.startTime && this.latitude && this.longitude;
    // Address is optional
    return result;
  }
}